<router-outlet>
    <div class="center-loginform" [@simpleFadeAnimation]="'in'">
        <app-login></app-login>
    </div>
</router-outlet>